import logsApi from 'configs/logsApi'
import { getClientDeviceInfo } from './clientDeviceInfo'
import type {
  SendTransactionalLogParams,
  TransactionalLogPayload,
} from './types'

const APP_NAME = 'health-team-platform'
const DEFAULT_SOURCE = 'frontend'

function getEnv(): string {
  const env = process.env.REACT_APP_ENV || process.env.NODE_ENV
  if (env === 'production') return 'production'
  if (env === 'staging') return 'staging'
  return env === 'development' ? 'development' : 'development'
}

function buildPayload(
  params: SendTransactionalLogParams
): TransactionalLogPayload {
  const {
    eventName,
    eventVersion = 1,
    actor,
    trace,
    target,
    result,
    meta = {},
    meta_raw,
    meta_dim,
    action = {},
  } = params

  const device = getClientDeviceInfo()

  return {
    ts: new Date().toISOString(),
    event_name: eventName,
    event_version: eventVersion,
    env: getEnv(),
    app: APP_NAME,
    source: DEFAULT_SOURCE,
    actor,
    trace,
    target,
    result,
    ...(device && { device: { ...device } }),
    meta: Object.keys(meta).length ? meta : undefined,
    ...(meta_raw && Object.keys(meta_raw).length > 0 && { meta_raw }),
    ...(meta_dim && Object.keys(meta_dim).length > 0 && { meta_dim }),
    action: Object.keys(action).length ? action : undefined,
  }
}

export async function sendTransactionalLog(
  params: SendTransactionalLogParams
): Promise<unknown | null> {
  if (!process.env.REACT_APP_LOGS_API_URL) {
    if (process.env.NODE_ENV === 'development') {
      console.debug(
        '[transactionalLog] REACT_APP_LOGS_API_URL não configurado, log omitido:',
        params.eventName
      )
    }
    return null
  }

  try {
    const payload = buildPayload(params)
    const { data } = await logsApi.post<unknown>(
      '/transaccional-logs',
      payload,
      {
        timeout: 3000,
      }
    )
    return data
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response?.status
    const data = (err as { response?: { data?: unknown } })?.response?.data
    console.warn('Falha ao enviar log transacional', {
      eventName: params.eventName,
      status,
      data,
    })
    return null
  }
}
